(function () {
  function safeJsonParse(el) {
    try {
      return JSON.parse(el.textContent || "{}");
    } catch (e) {
      return {};
    }
  }

  function getVariantIdFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("variant");
    return id ? String(id) : null;
  }

  function getCurrentVariantIdFromForm(root) {
    const input = root.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  function getRootForTitle() {
    // Main product title is unique per page; scope to document
    return document;
  }

  function updateProductTitle(root, variantId) {
    if (!variantId) return;

    const titleEl = root.querySelector("[data-product-title-id]");
    if (!titleEl) return;

    // Cache original title once
    if (!titleEl.dataset.originalTitle) {
      titleEl.dataset.originalTitle = titleEl.textContent.trim();
    }

    const jsonEl = root.querySelector(`#VariantTitleData-${titleEl.dataset.productTitleId}`);
    if (!jsonEl) return;

    const map = safeJsonParse(jsonEl);
    const title2 = (map[String(variantId)] || "").trim();

    titleEl.textContent = title2 ? title2 : titleEl.dataset.originalTitle;
  }

  // Variant article number: NO fallback to product-level.
  // If variant metafield is blank/missing, show blank.
  function updateArticleNumber(root, variantId) {
    if (!variantId) return;

    const titleEl = root.querySelector("[data-product-title-id]");
    if (!titleEl) return;

    const productId = titleEl.dataset.productTitleId;

    // Your Liquid should render this element between title and price:
    // <p data-article-number data-product-id="{{ product.id }}"><span data-article-number-value>...</span></p>
    const container = root.querySelector(`[data-article-number][data-product-id="${productId}"]`);
    if (!container) return;

    const valueEl = container.querySelector("[data-article-number-value]");
    if (!valueEl) return;

    const jsonEl = root.querySelector(`#VariantArticleData-${productId}`);
    if (!jsonEl) {
      // If the JSON map isn't present, default to blank (per your requirement)
      valueEl.textContent = "";
      return;
    }

    const map = safeJsonParse(jsonEl);
    const articleNumber = (map[String(variantId)] || "").trim();

    valueEl.textContent = articleNumber; // blank if missing/empty
  }

  // 1) Try to react to Ignite/Theme variant events if present
  document.addEventListener("variant-change", (e) => {
    const root = getRootForTitle();
    const variantId =
      (e && e.detail && e.detail.variant && e.detail.variant.id && String(e.detail.variant.id)) ||
      getCurrentVariantIdFromForm(root) ||
      getVariantIdFromUrl();

    updateProductTitle(root, variantId);
    updateArticleNumber(root, variantId);
  });

  // 2) Fallback: react to changes in the hidden variant id input (covers themes that don't emit variant-change)
  document.addEventListener("change", (e) => {
    const target = e.target;
    if (!target) return;

    if (target.matches('input[name="id"]')) {
      const root = getRootForTitle();
      const variantId = String(target.value);

      updateProductTitle(root, variantId);
      updateArticleNumber(root, variantId);
    }
  });

  // 3) Initial load (if page loads with a selected variant)
  document.addEventListener("DOMContentLoaded", () => {
    const root = getRootForTitle();
    const variantId = getCurrentVariantIdFromForm(root) || getVariantIdFromUrl();

    if (variantId) {
      updateProductTitle(root, variantId);
      updateArticleNumber(root, variantId);
    }
  });
})();